import React, { useEffect, useState } from "react";
import axios from "axios";
import Loading from "../../icons/Loading";
import ProgressBar from "../../cart-page/component/ProgressBar";

const LoyaltyStatus = () => {
  const [loyaltyData, setLoyaltyData] = useState([]);
  const [allowanceData, setAllowanceData] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadLoyaltyAndAllowanceData = async () => {
    try {
      setLoading(true);
      const [loyaltyResponse, allowanceResponse] = await Promise.all([
        axios.post('cart-api/loyalty-data'),
        axios.post('cart-api/allowance-data')
      ]);
      setLoyaltyData(loyaltyResponse.data);
      setAllowanceData(allowanceResponse.data);
    } catch (error) {
      console.error("Error loading data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLoyaltyAndAllowanceData();
  }, []);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <ProgressBar
          packages={loyaltyData}
          sample_allowance={allowanceData}
          name={allowanceData.account_name}
          hideMessage={true}
        />
      )}
    </>
  );
};

export default LoyaltyStatus;
